import { CellProps } from 'react-table';

import { IRow } from '@work4all/components/lib/dataDisplay/basic-table/types';

type Props = CellProps<IRow, number>;

export const TaxKeyCell = ({ value }: Props) => {
  return value ? Number(value) : null;
};
